import React, {useState,useContext, useEffect} from "react";
import { useSelector,shallowEqual } from "react-redux";
import { Link,useNavigate } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import PropTypes from "prop-types";
import {PermissionContext} from "../../../PermissionContext";
import List from "../../../common/List";
import { useStyles } from "./styles";
import NavbarLink from "./NavbarLink";
import { navbarItems,firstActiveRoute,isHidden,hasPermission } from "./constant";
import { MenuItem } from "@mui/material";
import Menu from '@mui/material/Menu';
import SvgIcon from "../../../common/SvgIcon";
import Fade from '@mui/material/Fade';

const NavigationBar = props => {
  const { clinicId, clinicDashboards } = useSelector(state => ({
    clinicId: state.clinicReducer.selectedClinicId,
    clinicDashboards: state.clinicReducer.clinicDashboards
  }), shallowEqual);
  const navigate = useNavigate();
  const permissionCtxt = useContext(PermissionContext);
  const { headerColor, checkPermission } = props;
  const classes = useStyles(props);
  const activeNavItems = props.activeLinks?navbarItems.filter(i=>props.activeLinks.includes(i.id)):navbarItems
  const [anchorEl, setAnchorEl] = useState({});

  useEffect(()=>{
    if(checkPermission){
      const {firstRoute,hasAccess,currentRoute,availableLinks} = firstActiveRoute(permissionCtxt,props.activeLinks);
      currentRoute && !hasAccess && console.log('re-route to firstRoute');
      currentRoute && !hasAccess && navigate(firstRoute);
    }
  },[checkPermission,clinicId,location.pathname])

  const handleMenu = (menuId) => (event) => {
    setAnchorEl({ [menuId]: event.currentTarget });
  };

  const handleClose = (e) => {
    e && e.stopPropagation()
    setAnchorEl({});
  };
  const refreshMenu = ()=>{
    const om = {...anchorEl};
    setAnchorEl({});
    setAnchorEl(om);
  }
  const navigateTo = (path) => {
    navigate(path);
    handleClose();
    //console.log('navigating to',path);
  }
  const isActive = navbarItem => {
    return navbarItem.activeLinks.some(link => window.location.pathname.includes(link)) ||  !!anchorEl[navbarItem.id]
  }

  return (
    <nav className={classes.navigationLinks} >
      <List display="inline" className={classes.navlist}>
        {activeNavItems.map(navbarItem => {
          if (navbarItem.type === "link") {
            return (
              isHidden(navbarItem,permissionCtxt)?'':<ListItem key={navbarItem.label} children={<NavbarLink {...navbarItem} headerColor={headerColor}  />} />
            );
          }
          if (navbarItem.type === "select"){
            return(isHidden(navbarItem,permissionCtxt)?'':
              <React.Fragment key={navbarItem.label}>
              <div className={classes.serviceSelectorContainer}>
              <div className={`${classes.dFlex} menu-link active-${isActive(navbarItem)} ${isActive(navbarItem)?classes.navLinkActive: classes.navLink}`} onClick={handleMenu(navbarItem.id)} onMouseEnter={handleMenu(navbarItem.id)}>
                <SvgIcon icon={navbarItem.icon} className="mr-4"/> {navbarItem.label}
              </div>
              <Menu
                id={navbarItem.id}
                anchorEl={anchorEl[navbarItem.id]}
                keepMounted
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                autoFocus={false}
                open={Boolean(anchorEl[navbarItem.id])}
                onClose={handleClose}
                TransitionComponent={Fade}
                slotProps={{
                  paper: {
                    elevation: 0,
                    sx: {
                      overflow: 'visible',
                      filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                      mt: 1.5,
                      background:'#FAFBFF',
                      '&::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: '50%',
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                      },
                    },
                  }
                }}
              >
                {navbarItem.services?.map(item => (
                  !hasPermission(item,permissionCtxt)?'':<MenuItem key={item.label} onClick={()=>navigateTo(item.to)}><Link className={`h-menuItem ${classes.dFlex} ${(window.location.pathname === item.to) ? classes.activeMenu : classes.menuItem}`} key={item.label} to={item.to} onClick={handleClose}><SvgIcon icon={item.icon} size="normal" className="mr-6"/>{item.label}</Link></MenuItem>
                ))}
                {navbarItem.component && navbarItem.component({permissionCtxt,handleClose,refreshMenu,open:Boolean(anchorEl[navbarItem.id])})}
              </Menu>
            </div>
            </React.Fragment>
            )
          }
          return null;
        })}
      </List>

    </nav>
  );
};

NavigationBar.propTypes = {
  navbarItems: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      activeLinks: PropTypes.arrayOf(PropTypes.string),
      label: PropTypes.string,
      openInNewTab: PropTypes.bool,
      to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    })
  ),
  headerColor: PropTypes.string,
};

export default NavigationBar;
